<template>
  <div class="width98 margin-auto">
    <div class="toolbtn flex">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <div class="width100 border-rd3 through flex-betweenNowrapAlign">
      <p class="pad-left20">
        <img src="@/assets/barsvg/icon／14zy.png" alt="" />
        <span class="f14 pad-left10" style="color: #6a7589"
          >商标注册通过率测试上线啦！</span
        >
      </p>
      <span class="f12 pad-right20" style="color: #969eac">
        注册前免费测一测，轻松了解商标通过率！
      </span>
    </div>
    <div class="width100 backwihte margin-top20 border-rd3 pad-bot20">
      <el-tabs v-model="activeName" class="width96 margin-auto pad-top10">
        <el-tab-pane label="按国际分类测试" name="first">
          <div class="passrateBox">
            <div class="itemnameBox">
              <el-checkbox-group
                v-model="checkedCities"
                :max="5"
                v-for="(item, index) in cities"
                :key="index"
                @change="PersonnelChange"
                class="itemname"
              >
                <el-checkbox :label="index">{{ item.tname }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="width98 margin-auto margin-top10">
              <p>
                <span
                  >商标名称:
                  <el-input
                    class="width20"
                    v-model="inputciti"
                    placeholder="请输入商标名称"
                  ></el-input
                ></span>
              </p>
              <p class="margin-top20">
                <el-button type="primary" @click="gotest()">开始测试</el-button>
              </p>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="按行业测试" name="second">
          <div class="passrateBox">
            <div class="itemnameBox">
              <el-checkbox-group
                v-model="checkedpages"
                :max="5"
                v-for="(item, index) in page"
                :key="index"
                @change="PersonnelChanges"
                class="itemname"
              >
                <el-checkbox :label="index">{{
                  item.industryName
                }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="width98 margin-auto margin-top10">
              <p>
                <span>商标名称：</span>
                <el-input
                  class="width20"
                  v-model="inputpage"
                  placeholder="请输入商标名称"
                ></el-input>
              </p>
              <p class="margin-top20">
                <el-button type="primary" @click="gotests()"
                  >开始测试</el-button
                >
              </p>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import BUS from "@/BUS/BUS";
import callback from "@/components/callback.vue";
import {
  trademarktoolsclass,
  trademarktoolsindustry,
} from "@/api/patent/patent.api";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      activeName: "first",
      checkedCities: [],
      cities: [],
      PersonnelChangeid: [],
      inputciti: "",
      citiclass: [],

      page: [],
      checkedpages: [],
      Personnelpageid: [],
      inputpage: "",
      pageclass: [],
    };
  },
  components: {
    callback,
  },
  methods: {
    // 获取选取国际分类测试id
    PersonnelChange(val) {
      this.PersonnelChangeid = val;
    },
    // 获取选取行业分类测试id
    PersonnelChanges(val) {
      this.Personnelpageid = val;
    },
    // 开始国际测试
    gotest() {
      if (this.inputciti == "") {
        this.dialogVisiblenull = true;
        this.errormessage = "请输入商标名称";
      } else if (this.PersonnelChangeid.length == 0) {
        this.dialogVisiblenull = true;
        this.errormessage = "请选择国际分类";
      } else {
        this.PersonnelChangeid.forEach((i) => {
          this.citiclass.push(parseInt(this.cities[i].tcode));
        });

        window.sessionStorage.setItem("citiclass", this.citiclass);
        window.sessionStorage.setItem("inputciti", this.inputciti);
        window.sessionStorage.setItem("truefalse", 0);
        this.$router.push({
          path: "/intellectual-property/Throughrate-details",
        });
      }
    },
    // 开始行业测试
    gotests() {
      if (this.inputpage == "") {
        this.dialogVisiblenull = true;
        this.errormessage = "请输入商标名称";
      } else if (this.Personnelpageid.length == 0) {
        this.dialogVisiblenull = true;
        this.errormessage = "请选择行业";
      } else {
        this.Personnelpageid.forEach((i) => {
          this.pageclass.push(parseInt(this.page[i].industryId));
        });
        window.sessionStorage.setItem("truefalse", 1);
        window.sessionStorage.setItem("pageclass", this.pageclass);
        window.sessionStorage.setItem("inputpage", this.inputpage);
        this.$router.push({
          path: "/intellectual-property/Throughrate-details",
        });
      }
    },
  },
  created() {
    // 获取商标国际分类
    trademarktoolsclass({}).then((res) => {
      if (res.data.code == 200) {
        this.cities = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });

    //   获取商标行业分类
    trademarktoolsindustry({}).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.through {
  height: 40px;
  line-height: 40px;
  position: relative;
  top: 5px;
  background: #fffaeb;
  border: 1px solid #ffc816;
}

.passrateBox {
  widows: 90%;
  margin: auto;
  /* background: #e4f5ff; */
  border-radius: 5px;
  padding: 0 0 20px 0;
}
.itemnameBox {
  width: 100%;
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  padding: 10px 0 10px 10px;
  line-height: 22px;
}

.itemname {
  width: 20%;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>